import React, { useState, useEffect } from 'react'
import { Typography, Stack, Box, Grid, Divider, Radio, Select, MenuItem, InputLabel, Button, Checkbox, TextField, IconButton, DialogContent, Dialog, DialogTitle, DialogContentText, DialogActions } from '@mui/material'
import PaynowIcon from "../../../../Icons/PaynowIcon.svg"
import VisaIcon from "../../../../Icons/Visa.svg"
import axios from 'axios'
import { useSelector } from 'react-redux'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import axiosInstance from '../../../../api/axiosInstance'
import { Close } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import success from '../../../../assets/tick-circle.png'
import failure from '../../../../assets/close-circle.png'
import pending from '../../../../assets/uiw_time.png'

export default function Payment({ setStepperCount }) {
  const data = useSelector((state) => state.AdminData.admin)
  const [allData, setAllData] = useState({})
  const language = useSelector((state) => state.language.language)
  const navigate = useNavigate()

  const [RoomsData, setRoomsData] = useState({})
  const [mainsAmounts, setMainAmounts] = useState([])

  const [paynowResponse, setPaynowResponse] = useState({})
const [openQr, setOpenQr] = useState(false)
const [timeLeft, setTimeLeft] = useState(10 * 60);
const [paynowStatus, setPaynowstatus] = useState("")


  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);

  useEffect(() => {
    let timer;
  
    if (openQr && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prev) => prev - 1);
      }, 1000);
    }
  
    if (timeLeft === 0) {
      setOpenQr(false);
      setTimeLeft(10 * 60)
      localStorage.removeItem("payment_id");
    }
  
    return () => clearInterval(timer);
  }, [openQr, timeLeft]);

  useEffect(() => {
    if (openQr === true) {
      const intervalId = setInterval(() => {
        GetPaymentStatus();
      }, 5000);
  
      return () => clearInterval(intervalId); // Cleanup on unmount
    }
  }, [openQr]);



  const fetchData = async () => {
      await axiosInstance.get(`${process.env.REACT_APP_API_URL}get-paiduser-by-id/${data.id}`)
      .then((response) => {
          console.log(response)
          if(response.status === 200){
              setAllData(response.data.data)
              setRoomsData(response.data.data.RoomsData)
          }
      })
      .catch((error) => console.log(error))
  }
  
  const fetchMainAmount = async () => {
    await axiosInstance.get(`${process.env.REACT_APP_API_URL}get-main-amounts`)
    .then((response) => {
      console.log(response)
      setMainAmounts(response?.data?.data)
    }).catch((error) => {
      console.log(error)
    })
  }

  useEffect(() => {
      if(data.id){
          fetchData()
          fetchMainAmount()
      }
  }, [])

  const stripHtml = (html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || "";
  };


  const roomRentTotal = (RoomsData?.contractLength === 1) ? (RoomsData?.selectedRoom?.six_month_cont * 6) : (RoomsData?.selectedRoom?.twelve_month_cont * 12)
  
  const otherFeeTotal = mainsAmounts?.reduce((sum, item) => sum + item.amount, 0)

  const TOTAL_AMOUNT_TO_PAY = roomRentTotal + otherFeeTotal

  const formattedTotal = TOTAL_AMOUNT_TO_PAY.toLocaleString('en-US');

  console.log(formattedTotal)

  
  const convertPrice = () => {
    return Math.round(Number((TOTAL_AMOUNT_TO_PAY * 100).toFixed(2)));
  }
  
  
  const handleSubmitPayment = async (e) => {
    if (e) {
      e.preventDefault(); // Only prevent default if e is provided
    }
    const price = convertPrice()
    console.log(price)
  
    try {
      if (window.OmiseCard) {
        window.OmiseCard.open({
          amount: price,
          currency: "SGD",
          frameLabel: "Vinga International",
          submitLabel: "Pay Now",
          // otherPaymentMethods: [
          //   "alipay_hk",
          //   "kakaopay",
          //   "touch_n_go",
          //   "wechat_pay",
          //   "paynow",
          // ],
          onCreateTokenSuccess: handleOmiseResponse,
          onFormClosed: () => {
            console.log("Payment form closed");
            //  setSelectedPayment({})
            // setCloseWindow(true)
          },
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
  
  

  



  // Helper function to format time as MM:SS
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  };
  
  
  const handleOmisePayNowResponse = async () => {
  
    const price = convertPrice()
    
    try {
      const response = await axiosInstance.post(
        `/charge/paynow`,
        {
          user_id : data?.id,
          amount: price,
        }
      );
      console.log('response', response)
      console.log("Charge response:", response.data);
      localStorage.setItem("payment_id", response?.data?.id);
      setPaynowResponse(response.data)
      setOpenQr(true)
     
      // if (response.data.authorize_uri) {
      //   window.location.href = response.data.authorize_uri;
      // } else {
      //   console.log("Charge response:", response.data.authorize_uri);
      // }
    } catch (error) {
      console.error("Error processing payment:", error);
      
    }
  };
  
  const sendMail = async (to, subject, text) => {
    try {
      const response = await axiosInstance.post(`send-mail`, {
        email : to,
        subject,
        text
      })
      console.log(response)
    } catch (error) {
      console.log(error)
    }
  }
  
  const GetPaymentStatus = async () => {
    
    try {
      const response = await axiosInstance.post(
        `get-payment-details-by-id`,
        { payment_id : paynowResponse?.id },
      );
  
      const payment = response?.data?.details?.payment;
      console.log("Payment Response:", payment);
  
      if (response.status === 200 && payment) {
        // setStatus(payment.status);
        const adminEmail = process.env.REACT_APP_ADMIN_EMAIL;
        let subject = "";
        let text = "";
        let adminSubject = "";
        let adminText = "";
        if (payment.paid && payment.status === "successful") {
          subject = "Tenancy Agreement Received Successfully";
          text = `Hi ${data.name},\n\nWe've received your tenancy agreement. Our team will review the submission and provide further instructions soon.\n\nThank you,\nThe Vinga Team`;
        
          adminSubject = "New Tenancy Agreement Submission from Vinga";
          adminText = `A tenancy agreement has been submitted by ${data.userName}. Please review it in the admin system.`;
          setOpenQr(false)
          setPaynowstatus("success")
          setOpen1(true)
  
          localStorage.removeItem("payment_id")
          Promise.all([
            handleSubmit(payment.id),
            sendMail(data.userName, subject, text),
            sendMail(adminEmail, adminSubject, adminText)
          ])
          .then(() => {
            console.log("Both emails sent successfully.");
          })
          .catch((error) => {
            console.error("Error sending one or both emails:", error);
          });
          return;
        }
  
        if (!payment.paid && payment.status === "pending") {
          // setPaynowstatus("pending")
          // setOpen1(true)
          return; // Continue polling
        }
  
        if (payment.status === "failed") {
          subject = "Application Submission Failed";
          text = `Hi ${data.name},\n\nIt seems your application payment failed. Please retry the payment process to complete your application.\n\nRegards,\nThe Vinga Team`;

          adminSubject = "Application Payment Failed from Vinga";
          adminText = `Payment failed for application by ${data.userName}.`;
          setOpenQr(false)
          setPaynowstatus("failed")
          setOpen1(true)
          localStorage.removeItem("payment_id")
          
          Promise.all([
            sendMail(data.userName, subject, text),
            sendMail(adminEmail, adminSubject, adminText)
          ])
          .then(() => {
            console.log("Both emails sent successfully.");
          })
          .catch((error) => {
            console.error("Error sending one or both emails:", error);
          });
          return;
        }
      }
    } catch (error) {
      console.error("Error fetching payment status:", error);
    }
  };
  

  
  
  
  const handleOmiseResponse = async (tokenID) => {
    // const { user_id, application_id } = ;
    console.log(tokenID)
    setOpen(true)
    const price = convertPrice()
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}charge`,
        {
          token: tokenID,
          user_id : data?.id,
          amount: price,
          user_email: data?.email,
        }
      );
      console.log(response)
      console.log("Charge response:", response.data);
      localStorage.setItem("payment_id", response.data.id)
      localStorage.setItem("pageNavigate", "tenancy")
      if(response.status === 200){
        handleSubmit(response?.data?.id)
      }
      
  
      if (response.data.authorize_uri) {
        window.location.href = response.data.authorize_uri;
      } else {
        console.log("Charge response:", response.data.authorize_uri);
      }
    } catch (error) {
      console.error("Error processing payment:", error);
     
    }
  };
  


  const handleSubmit = async (paymentid) => {
     await axiosInstance.post(`${process.env.REACT_APP_API_URL}get-tenancy-payment/${data.id}`, {payment_id : paymentid})
     .then((response) => {
       console.log(response)
     }).catch((error) => {
       console.log(error)
     })
  }


  return (
    <>
      <Box px={{ md: 10, xs: 3 }}>
      <Typography sx={{pb : 4, ":hover" : {cursor : 'pointer'}}} onClick={() => setStepperCount(1)}><ArrowBackIcon sx={{fontSize : '30px'}}/></Typography>
        <Typography variant="h6_1">Payment</Typography>
        <Grid mt={3} mb={6} container rowGap={7}>
          <Grid xs={12} sx={{ display: "flex", flexDirection: "column" }} rowGap={2} gap={2}>
            <Divider />
            <Stack my={1} direction="row" justifyContent="space-between" alignItems="center">
              <Stack gap="8px" width='50%'>
                <Typography variant="h6_1">Room Rent</Typography>
                <Typography variant='h9_4' >{RoomsData?.selectedRoom?.HostelName?.[language]}</Typography>
                <Typography variant='h9_4' >{RoomsData?.selectedRoom?.room_type_name?.[language]}</Typography>
              </Stack>
              <Typography variant="h6_1">{`S$ ${RoomsData?.contractLength === 1 ? RoomsData?.selectedRoom?.six_month_cont : RoomsData?.selectedRoom?.twelve_month_cont} * ${RoomsData?.contractLength === 1 ? '6' : '12'}`}</Typography>
            </Stack>
            <Divider />
            {mainsAmounts.map((main, index) => (
              <>
              <Stack my={1} direction="row" justifyContent="space-between" alignItems="center">
              <Stack gap="8px" width='50%'>
                <Typography variant="h6_1">{main?.title}</Typography>
                <Typography variant='h9_4' >{stripHtml(main?.description || '-')}</Typography>
              </Stack>
              <Typography variant="h6_1">S$ {main?.amount}</Typography>
            </Stack>
            <Divider />
            </>
            ))}
            
            {/* <Stack my={1} direction="row" justifyContent="space-between" alignItems="center">
              <Stack gap="8px" width='50%'>
                <Typography variant="h6_1">Fixed fee</Typography>
                <Typography variant='h9_4' >A fixed additional fee for the room</Typography>
              </Stack>
              <Typography variant="h6_1">S$ 50</Typography>
            </Stack>
            <Divider /> */}
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Stack gap="8px" width='50%'>
                <Typography variant="h6_1">Total</Typography>
              </Stack>
              <Typography variant="h6_1">S$ {formattedTotal}</Typography>
            </Stack>
            <Stack mt={10} direction="column" justifyContent="space-between" alignItems="center" gap="10px">
              <Typography variant="h6_1">Pay Via</Typography>
              <Stack gap="8px" direction={{xs : 'column', lg : 'row'}} justifyContent="space-between" alignItems="center">
                <Stack onClick={() => handleSubmitPayment()} alignItems="center" justifyContent="center" height="44px" width="200px" border=".5px solid #1A2461" sx={{ borderRadius: "8px", ":hover" : {cursor : "pointer"} }}>
                  <Box margin="0 auto" component="img" src={VisaIcon}></Box>
                </Stack>
                <Stack onClick={() => handleOmisePayNowResponse()} alignItems="center" justifyContent="center" height="44px" width="200px" border=".5px solid #1A2461" sx={{ borderRadius: "8px", ":hover" : {cursor : 'pointer'} }}>
                  <Box margin="0 auto" component="img" src={PaynowIcon}></Box>
                </Stack>
                {/* <Stack alignItems="center" justifyContent="center" height="44px" width="200px" border=".5px solid #1A2461" sx={{ borderRadius: "8px" }}>
                  <Box margin="0 auto" component="img" src={VisaIcon}></Box>
                </Stack> */}
                {/* <Button onClick={() => {
                  setStepperCount(3)
                  handleSubmit()
                  }}>Paid</Button> */}
              </Stack>
            </Stack>
          </Grid>
        </Grid>


        <Dialog
        open={open}
        // onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Payment processing"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Payment processing, please wait...
          </DialogContentText>
        </DialogContent>
       
      </Dialog>

        <Dialog
        open={open1}
        // onClose={handleClose1}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        onClose={(event, reason) => {
          if (reason === "backdropClick") return; // Prevent closing on backdrop click
        }}
      >
        {/* <DialogTitle id="alert-dialog-title">
          {"Payment Failed"}
        </DialogTitle> */}
        {paynowStatus === 'success' && (
          <Box sx={{padding : '20px'}}>
        <DialogContent >
          <Box sx={{display : 'flex', justifyContent : 'center'}}>
          <Box sx={{display : 'flex', justifyContent : 'center', alignItems :'center', width : '150px', height : '150px', backgroundColor : '#D1FADF80', borderRadius : '100%'}}>
              <Box component={'img'} src={success} sx={{width : '80px'}}></Box>
          </Box>
          </Box>
          <Box sx={{mt : 2, display : 'flex', justifyContent : 'center'}}>
              <Typography sx={{fontSize : '36px', fontWeight : 700}}>Payment Successful</Typography>
          </Box>
          <Box sx={{mt : 1, diplay : 'flex', justifyContent : 'center'}}>
              <Typography sx={{fontSize : '24px', color : '#737373', textAlign : 'center'}}>Your payment for the <b>Application</b> service has been successfully received</Typography>
          </Box>
          <Box sx={{mt : 2, display : 'flex', justifyContent : 'center', flexDirection : 'column', gap : 1}}>
                <Typography sx={{fontSize : '24px', color : '#737373', textAlign : 'center'}}>Total Payment</Typography>
                <Typography sx={{fontWeight : 700, fontSize :'36px', textAlign : 'center'}}>S$ {formattedTotal}</Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => navigate('/account')} variant='contained' sx={{width : '100%', fontSize : '24px', fontWeight : 700}}>Go To Account</Button>
          
        </DialogActions>
        </Box>
        )}

{paynowStatus === 'failed' && (
          <Box sx={{padding : '20px'}}>
        <DialogContent >
          <Box sx={{display : 'flex', justifyContent : 'center'}}>
          <Box sx={{display : 'flex', justifyContent : 'center', alignItems :'center', width : '150px', height : '150px', backgroundColor : '#F6D2D2', borderRadius : '100%'}}>
              <Box component={'img'} src={failure} sx={{width : '80px'}}></Box>
          </Box>
          </Box>
          <Box sx={{mt : 2, display : 'flex', justifyContent : 'center'}}>
              <Typography sx={{fontSize : '36px', fontWeight : 700}}>Payment Failed</Typography>
          </Box>
          <Box sx={{mt : 1, diplay : 'flex', justifyContent : 'center'}}>
              <Typography sx={{fontSize : '24px', color : '#737373', textAlign : 'center'}}>Your payment for the <b>Application</b> service has failed. Please try again</Typography>
          </Box>
          <Box sx={{mt : 2, display : 'flex', justifyContent : 'center', flexDirection : 'column', gap : 1}}>
                <Typography sx={{fontSize : '24px', color : '#737373', textAlign : 'center'}}>Total Payment</Typography>
                <Typography sx={{fontWeight : 700, fontSize :'36px', textAlign : 'center'}}>S$ {formattedTotal}</Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen1(false)} variant='contained' sx={{width : '100%', fontSize : '24px', fontWeight : 700}}>Retry</Button>
          
        </DialogActions>
        </Box>
        )}

{paynowStatus === 'pending' && (
          <Box sx={{padding : '20px'}}>
        <DialogContent >
          <Box sx={{display : 'flex', justifyContent : 'center'}}>
          <Box sx={{display : 'flex', justifyContent : 'center', alignItems :'center', width : '150px', height : '150px', backgroundColor : '#FEF3C6', borderRadius : '100%'}}>
              <Box component={'img'} src={pending} sx={{width : '80px'}}></Box>
          </Box>
          </Box>
          <Box sx={{mt : 2, display : 'flex', justifyContent : 'center'}}>
              <Typography sx={{fontSize : '36px', fontWeight : 700}}>Payment Pending</Typography>
          </Box>
          <Box sx={{mt : 1, diplay : 'flex', justifyContent : 'center'}}>
              <Typography sx={{fontSize : '24px', color : '#737373', textAlign : 'center'}}>Your payment for the <b>Application</b> is pending. Please wait the payment to proceed</Typography>
          </Box>
          <Box sx={{mt : 2, display : 'flex', justifyContent : 'center', flexDirection : 'column', gap : 1}}>
                <Typography sx={{fontSize : '24px', color : '#737373', textAlign : 'center'}}>Total Payment</Typography>
                <Typography sx={{fontWeight : 700, fontSize :'36px', textAlign : 'center'}}>S$ {formattedTotal}</Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={() => setOpen1(false)} variant='contained' sx={{width : '100%', fontSize : '24px', fontWeight : 700}}>Retry</Button> */}
          
        </DialogActions>
        </Box>
        )}
        
      </Dialog>


      <Dialog
      open={openQr}
      maxWidth="lg"
     sx={{borderRadius : '20px'}}
      onClose={(event, reason) => {
        if (reason === "backdropClick") return; // Prevent closing on backdrop click
      }}
    >
      <DialogTitle sx={{ borderBottom: "2px solid #eceef3", backgroundColor : '#7C1A78' }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography style={{ fontSize: "20px", fontWeight: 600, color : 'white' }}>
            Scan QR code
          </Typography>
          <Close
          sx={{color : 'white'}}
            onClick={() => {
              setOpenQr(false)
              setTimeLeft(10 * 60)
            localStorage.removeItem("payment_id")
            
            }}
            style={{ cursor: "pointer" }}
          />
        </Box>
      </DialogTitle>
      <DialogContent sx={{backgroundColor : '#7C1A78'}}>
      <Box sx={{display : 'flex', justifyContent : 'center', alignItems : 'center', mt : 2, mb : 2}}>
    <Typography style={{ fontSize: "16px", fontWeight: 500, color : 'white' }}>
            Time Left: {formatTime(timeLeft)}
          </Typography>
          </Box>
          
          
      
      <img
        src={paynowResponse?.source?.scannable_code?.image?.download_uri}
        alt="QR Code"
        style={{ width: "300px", height: "300px", display: "block", margin: "auto", borderRadius : '8px'}}
      />

<Box sx={{display : 'flex', justifyContent : 'center', alignItems : 'center', pt : '20px'}}>
            <Typography sx={{fontWeight : 500, fontSize : '1.4rem', color : 'white'}}>Application</Typography>
          </Box>
<Box sx={{display : 'flex', justifyContent : 'center', alignItems : 'center', pt : '10px'}}>
            <Typography sx={{fontWeight : 700, fontSize : '1.4rem', color : 'white'}}>S$ {formattedTotal}</Typography>
          </Box>

</DialogContent>
    </Dialog>
      </Box>

    </>
  )
}
